import SignupPage from "../components/Auth/components/signup";
import React from "react";
export default function Signup() {
  return (
    <div className="">
      
      <SignupPage />
    </div>
  );
}